export const SET_PENDING_MUSIC = 'SET_PENDING_MUSIC'

export const UPDATE_PENDING_MUSIC = 'UPDATE_PENDING_MUSIC'